import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../../common/TableDefinitions';
import EdiRfidAuditRequestExecutionReportColumns from '../../containers/EdiRfidAuditRequestExecutionReportColumns';

export const getIsLoading = (state) => state.listing.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.isLoading;
export const getData = TableDefinitions.EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT.getDataFunction();
export const getColumns = createSelector(getData, EdiRfidAuditRequestExecutionReportColumns);
